import { productCategories } from '@/mocks/productsData';

function ProductCard({ product }: { product: (typeof productCategories)[0]['products'][0] }) {
  return (
    <a
      href={product.url}
      target="_blank"
      rel="noopener nofollow"
      className="group block bg-white rounded-lg border border-background-200 hover:border-primary-300 transition-all overflow-hidden cursor-pointer"
      title={product.title}
    >
      <div className="w-full aspect-square bg-background-100 overflow-hidden">
        <img
          src={product.image}
          alt={product.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-xs md:text-sm font-medium text-foreground-900 leading-tight line-clamp-2 min-h-[2.5em] mb-2">
          {product.title}
        </h3>
        <p className="text-sm md:text-base font-bold text-primary-600 mb-3">
          {product.price}
        </p>
        <span className="inline-flex items-center justify-center w-full px-3 py-2 rounded-md bg-primary-500 text-white text-xs md:text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap">
          Buy Now
        </span>
      </div>
    </a>
  );
}

export default function ProductShowcase() {
  return (
    <section id="products" className="w-full bg-background-50 py-12 md:py-20">
      <div className="section-container">
        <div className="section-inner">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 font-heading">
              Featured Products from Kakobuy Spreadsheet
            </h2>
            <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
              Browse curated products across all categories. Click any item to view details and purchase on our main store.
            </p>
          </div>

          <div className="space-y-14 md:space-y-20">
            {productCategories.map((category) => (
              <div key={category.slug}>
                <div className="flex items-center justify-between mb-5 md:mb-6">
                  <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground-900 font-heading">
                    {category.name}
                  </h3>
                  <a
                    href={category.categoryUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm md:text-base font-medium text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap"
                  >
                    View All
                    <i className="ri-arrow-right-line text-sm" />
                  </a>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
                  {category.products.map((product) => (
                    <ProductCard key={product.id} product={product} />
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-14 md:mt-20 text-center">
            <a
              href="https://kaspreadsheet.com/index.html"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-lg bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Browse Full Product Catalog
              <i className="ri-external-link-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}